import {initMainHeader} from '../js/src/header-init';
import {addThirdPartyLoad, loadJsScript} from "../js/src/utils";
import '../scss/pages/customer-reviews.scss';

initMainHeader();

addThirdPartyLoad(() => {
    loadJsScript('https://api.resellerratings.com/assets/script/deeaf3664dfcbd21d5b2ce4052a78282e');
});
